import { transformValues } from './transformValues';

export { transformValues };

export const checkPrice = (_rule, { price }, callback) => {
  if (price > 0) {
    return callback();
  }

  callback('Укажите сумму');
};

export const requiredRule = ({ msg, type = 'string' }) => ({
  required: true,
  message: msg,
  type,
  ...(type === 'string' ? { whitespace: true } : null),
});

export const transformPrice = (value) => {
  const number = Number(value.price);

  return {
    ...value,
    price: isNaN(number) ? 0 : number,
  };
};
